/**
 * presentations/components/pages/ActionDetails.tsx
 */

import { LandingTopWidget } from '../landing';
import { ActionDetailTopMain } from './top/TopMain';
import { ActionDetailsTabsDetails } from './tabsDetails/TabsDetails';
import { MainDetails } from './mainDetails/MainDetails';
import { NoRateCardModal } from './noRateCard/NoRateCardModal';
import { useNoRateCardSelector } from './noRateCard/Selector';
import { UploadModal } from './UploadDocument/UploadModal';
import { LayoutSidebar } from '../sidebar/LayoutSidebar';

const ActionDetailsMainContent = () => {
  const { isShowModal } = useNoRateCardSelector();

  return (
    <>
      <div className='h-full flex flex-col bg-white'>
        <LandingTopWidget />

        <LayoutSidebar>
          <ActionDetailTopMain />
          <div className='w-full flex-1 bg-neutral-10'>
            <div className='flex h-[calc(100vh_-_125px)] overflow-hidden'>
              <div className='w-1/2 bg-neutral-10'>
                <ActionDetailsTabsDetails />
              </div>
              <div className='w-1/2 bg-white border-l-1 border-neutral-20'>
                <MainDetails />
              </div>
            </div>
          </div>
        </LayoutSidebar>
      </div>
      <UploadModal />
      {isShowModal && <NoRateCardModal />}
    </>
  );
};

export default ActionDetailsMainContent;
